<template>
  <div class="tel-bind">
    <h3>修改手机号-设置绑定手机号</h3>
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="新手机号" prop="phone">
        <el-input v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="new_code">
        <el-input v-model="form.new_code" style="width: 62%;padding-right: 19px;"></el-input>
        <el-button type="primary" @click="getCode" v-if="!sendStatus" style="width:100px;">获取验证码</el-button>
        <span v-else class="timer">重新获取({{countdown}}s)</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('form')">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "add",
  data() {
    var checkTel = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        return callback(new Error("请输入正确的手机号码"));
      }
      callback();
    };
    return {
      sendStatus: false,
      countdown: "",
      form: {
        phone: "",
        new_code: "",
        type: '',
        code:''
      },
      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "change" },
          { validator: checkTel, trigger: "blur" }
        ],
        new_code: [{ required: true, message: "请输入验证码", trigger: "change" }]
      }
    };
  },
  methods: {
    getCode() {
      if (!/^1[3456789]\d{9}$/.test(this.form.phone)) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning"
        });
        return;
      }
      _api.personal.getCode({ code_type: "3", value: this.form.phone }).then(res => {
        this.sendStatus = true;
        this.countdown = 59;
        let timer = setInterval(() => {
          this.countdown--;
          if (this.countdown < 1) {
            this.sendStatus = false;
          }
        }, 1000);
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          _api.personal.updatePhone(this.form).then(res => {
            if (res.data == 1) {
              this.$router.push("/modifyTel/success");
            }else if(res.data == 2){
              this.$message.error('旧手机号验证码错误');
            }else if(res.data == 3){
              this.$message.error('新手机号验证码错误');
            }else if(res.data == 4){
              this.$message.error('新手机号验证码失效');
            }else if(res.data == 5){
              this.$message.error('旧手机号验证码失效');
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  created() {
    this.form.code = this.$route.query.code
    this.form.type = this.$route.query.type
  }
};
</script>

<style lang="scss" scoped>
.tel-bind {
  display: flex;
  flex-direction: column;
  align-items: center;
  h3 {
    margin: 30px 0 50px;
  }
  .tip {
    margin: 20px 0 30px;
    font-size: 14px;
  }
  button {
    width: 120px;
    height: 36px;
    font-size: 12px;
  }
}
.timer {
  display: inline-block;
  width: 100px;
}
</style>
<style lang="scss">
</style>
